'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { Button } from '@/components/ui/button'
import { Icons } from '@/components/ui/icons'

export default function RouteError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className='flex flex-1 flex-col items-center justify-center gap-4 py-16 text-center'>
      <Icons.alertTriangle className='h-10 w-10 text-red-500' strokeWidth={1.5} />
      <div>
        <h2 className='font-display text-display-4 text-brand-navy'>Something went wrong</h2>
        <p className='mx-auto mt-1 max-w-md text-sm text-brand-muted'>
          {error.message || 'An unexpected error occurred while rendering this page.'}
        </p>
      </div>
      <div className='flex gap-2'>
        <Button variant='gradient' onClick={reset}>
          Try again
        </Button>
        <Button variant='outline' asChild>
          <Link href='/dispute-explorer'>Back to Dispute Explorer</Link>
        </Button>
      </div>
    </div>
  )
}
